export const HOME = {
    TITLE: "Riva",
    WELCOME: "Hi",
    WELCOME_TEXT: "Welcome to GFNApp! Our cutting-edge molecular graph generative AI (GFN) model, developed by AADS, is now at your fingertips. Designed to empower discovery scientists, GFNApp allows you to harness the power of this advanced tool without needing any programming skills or an AI/ML background.GFN is a cutting-edge AI tool designed to accelerate small molecule discovery by augmenting design from expert human intuitions. Our GFN model leverages advanced generative AI techniques to create *diverse* and *synthesizable* molecular graphs that meet user specified drug-like properties. GFN follows a fragment-based drug discovery approach by taking a set of fragments as inputs and learning to assemble them like Lego blocks while maintaining a constant chemical scaffold of interest.",
    WELCOME_TEXT_PART1:"Welcome to GFNApp!",
    WELCOME_TEXT_PART2:"Our cutting-edge molecular graph generative AI (GFN) model, developed by AADS, is now at your fingertips. Designed to empower discovery scientists, GFNApp allows you to harness the power of this advanced tool without needing any programming skills or an AI/ML background.",
    WELCOME_TEXT_PART3:"GFN is a cutting-edge AI tool designed to accelerate small molecule discovery by augmenting design from expert human intuitions. Our GFN model leverages advanced generative AI techniques to create *diverse* and *synthesizable* molecular graphs that meet user specified drug-like properties. GFN follows a fragment-based drug discovery approach by taking a set of fragments as inputs and learning to assemble them like Lego blocks while maintaining a constant chemical scaffold of interest.",
    ATTRIBUTES: "Submit New Generation",
    RESULTS: "View Results",
    FEEDBACK: "Provide Feedback",
    LOGOUT: "Logout",
};

export const WELCOME_TEXT_HTML = `
  Welcome to Riva App! <br/>   <br /> Our cutting-edge molecular graph generative AI (GFN) model, 
  developed by AADS, is now at your fingertips. Designed to empower discovery 
  scientists, Riva allows you to harness the power of this advanced tool 
  without needing any programming skills or an AI/ML background.
  <br/>   <br />
  GFN is a cutting-edge AI tool designed to accelerate small molecule discovery by 
  augmenting design from expert human intuitions. Our GFN model leverages 
  advanced generative AI techniques to create <em>diverse</em> and <em>synthesizable</em> 
  molecular graphs that meet user specified drug-like properties. Riva follows a 
  fragment-based drug discovery approach by taking a set of fragments as inputs and learning to 
  assemble them like Lego blocks while maintaining a constant chemical scaffold of interest. 
`

export const PeoplePickerLabels = {
    START_SEARCHING: "Type to start searching",
    SEARCHING: "Searching...",
    NO_RECORD: "No matching records found.",
    MAX_SELECTION_COUNT: 9
  };

  export const CALLBACK_TIMEOUT_DURATION = 400;
  export const SUGGEST_PEOPLE_CHAR_LENGTH = 3;
  export const DROPDOWN_DEFAULT = {
    SELECT_AN_OPTION: "Add your Team Members Here",
    DEFAULT_VALUE: [{ mr_record_id: "", value: "Add your Team Members Here" }],
    DEFAULT_VALUE_MONITORING: [{ key: "", value: "Add your Team Members Here" }]
  }

export const dataTypes = {
    string: "string",
    date: "date",
    number: "number",
};

export const BUTTON_LABEL = {
    CANCEL: "CANCEL",
    SUBMIT: "SUBMIT",
    CLOSE: "CLOSE",
    CREATE: "CREATE",
    UPDATE: "UPDATE",
};

export const ATTRIBUTE = {
    GENERATING_IMAGE: "Generating image...",
    SMILES_INPUT: "Enter Smiles",
    MANDATORY_PARAMETERS: "Property Constraints",
    ADVANCE_PARAMETERS: "Advance Parameters",
    SUBMIT_MSG: "Data has been submitted successfully",
    BATCH_NUMBER: "Batch Number:",
    TIME_STAMP: "Submitted Time Stamp :",
    SUBMITTED_BY: "Submitted by :",
    OPEN_RESULT_PAGE: "Open result page",
};

export const FEEDBACK = {
    TEXT: "Provide Your Feedback",
    SUBMITTED: "Feedback Submitted",
    SUBMITTED_MSG: "Thank you for providing your feedback!",
    SUCCESS_MSG: "Feedback submitted successfully!",
};

export const RESULT = {
    NO_DATA: "No data available",
    DETAILS: "Details",
    BATCH_VARIATION: "Batch Variation",
    SMILE_STRING: "SMILE String",
    PICTORIAL_REPRESENTATION: "Pictorial Representation",
    CALCULATED_REWARD: "Calculated Reward",
    SUBMIT_GENERATION: "submit new generation",
};

export const CHEMDRAW = {
    LICENSE_URL : "https://cdjs-q.apps-internal.lrl.lilly.com/ChemDraw-JS-License.xml",
    CHEM_SERVICE_URL:"https://cdws-q.apps-internal.lrl.lilly.com/1.0"
};

export const HELPER = {
    SCAFFOLD: "Enter SMILES or draw the scaffold structure. Attachment points need to be labeled as '*'",
    CAPPING: "Enter SMILES or draw the capping structure. Attachment points need to be labeled as '*'"
};